<template>
    <div class="content">
        <div class="header-container">
            <ul class="headLine">
                <li v-if="isLogin" class="avatar-container"><span class="avatar"></span><p>{{name}}</p></li>
                <li @click="navigateTo('login')" v-if="isLogin===false" :class="language==='en-US' ? 'on' : ''"><span v-text="language=='zh-CN' ? '登' : 'L'"></span><p v-text="language=='zh-CN' ? '录' : 'og In'"></p></li>
                <li @click="loginOut" v-if="isLogin" :class="language==='en-US' ? 'on' : ''"><span v-text="language=='zh-CN' ? '退' : 'L'"></span><p v-text="language=='zh-CN' ? '出' : 'og out'"></p></li>
                <li v-show="dailyEvent_ZH || dailyEvent_EN" @click="navigateToPDF" :class="language==='en-US' ? 'on' : ''"><span v-text="language=='zh-CN' ? '赛' : 'E'"></span><p v-text="language=='zh-CN' ? '事日程' : 'vent Schedule'"></p></li>
                <li :class="language==='en-US' ? 'on' : ''" @click="changeLanguage"><span v-text="language=='zh-CN' ? 'E' : 'C'"></span><p v-text="language=='zh-CN' ? 'N' : 'N'"></p></li>
            </ul>
            <div class="mainBg">
                <img v-show="logoImg" @click="navigateTo('index')" class="title" :src="logoImg">
                <div class="search-container">
                    <div class="searchTool-container">
                        <!-- <div @click="voiceSearch" :class="language==='en-US' ? 'voice-container on' : 'voice-container'">
                            <img src="../assets/voiceIconBlue.png">
                            <p v-text="$t('m.voiceSearch')"></p>
                        </div>
                        <div @click="picSearch" :class="language==='en-US' ? 'pic-container on' : 'pic-container'">
                            <img src="../assets/picIconBlue.png">
                            <p v-text="$t('m.picSearch')"></p>
                        </div>
                        <div @click="faceSearch" :class="language==='en-US' ? 'face-container on' : 'face-container'">
                            <img src="../assets/faceIconBlue.png">
                            <p v-text="$t('m.faceSearch')"></p>
                        </div> -->
                    </div>
                    <div class="searchInput-container">
                        <input @keyup.enter="searchKeyWord" @focus="isFocus=true;" @blur="leaveFocus" v-model="search" type="text">
                        <div class="delIcon">
                            <img @click="delSearch" v-if="isFocus&&!isNull" src="../assets/delOn.png">
                        </div>
                        <div @click="searchKeyWord" class="searchIcon"></div>
                    </div>
                </div>
                <div class="searchTag-container">
                    <ul class="mainTag">
                        <li v-for="(item,key) in searchList.category" @click="changeCategoryType(key,item.key)" :class="index===key ? 'on' : ''" v-text="$t('m.'+item.key)"></li>
                        <!-- <li v-if="role==1" @click="changeProjectDownload(99)" :class="index===99 ? 'on' : ''" v-text="$t('m.projectFile')"></li> -->
                    </ul>
                    <ul v-if="!isProjectDownload" :class="categoryType=='match' ? 'dateTag on' : 'dateTag'">
                        <li>{{$t('m.date')}}：</li>
                        <ul>
                            <li @click="dateIndex=99;dateType='';pageIndex=1;getSearchList()" :class="dateIndex===99 ? 'on' : ''">{{$t('m.all')}}</li>
                            <li v-for="(item,index) in searchList.date" @click="setDateSearchList(item.key,index)" :class="saveDateIndex>=index ? dateIndex===index ? 'on' : '' : 'un'">{{item.title}}</li>
                        </ul>
                    </ul>
                    <ul v-if="!isProjectDownload&&categoryType!='match'" class="sportTag">
                        <li>{{$t('m.classify')}}：</li>
                        <ul :class="language==='en-US' ? 'on' : ''">
                            <li @click="typeIndex=99;type='';pageIndex=1;getSearchList()" :class="typeIndex===99 ? 'on' : ''">{{$t('m.all')}}</li>
                            <li v-for="(item,index) in searchList.type" @click="typeIndex=index;type=item.key;getSearchList()" :class="typeIndex===index ? 'on' : ''" v-text="language==='en-US' ? item.en_title : item.zh_title"></li>
                        </ul>
                    </ul>
                </div>
                <ul v-if="!isProjectDownload" class="videoList-container">
                    <li @click="navigateToDetail(item.mediaId,item.category)" v-for="item in searchList.list">
                        <div class="img-container">
                            <img :src="item.cover">
                            <div class="timeInfo">
                                <img src="../assets/rightArrow.png">
                                <p>{{item.time}}</p>
                            </div>
                        </div>
                        <div class="info">
                            <p class="content">{{item.title}}</p>
                            <p class="size">{{$t('m.size')}}：{{item.size}}</p>
                            <p class="date">{{item.date}}</p>
                        </div>
                    </li>
                </ul>
                <ul v-if="isProjectDownload" class="downLoadList-container">
                    <li v-for="item in projectFileList">
                        <p>{{item.basename}}</p>
                        <span @click="projectFileDownload(item.basename)" v-text="$t('m.downLoad')"></span>
                    </li>
                </ul>
            </div>
            <el-pagination
                :class="language==='en-US' ? 'on' : ''"
                layout="pager"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-size="pageNum"
                :total="pageTotal">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import bus from '../bus'
import { parse } from 'path';
export default {
    name: 'searchList',
    data() {
        return {
            name: '',
            uid: '',
            unid: '',
            role: '',
            search: '',
            dailyEvent_ZH: '',
            dailyEvent_EN: '',
            searchList: [],
            projectFileList: [],
            language: 'zh-CN',
            isLogin: false,
            isPc: true,
            isProjectDownload: false,
            isNull: true,
            isFocus: false,
            categoryType: 'match',
            dateType: '',
            type: '',
            date: '',
            logoImg: '',
            pageIndex: 1,
            pageNum: 8,
            pageTotal: 200,
            dateIndex: 99,
            typeIndex: 99,
            index: 2,
            saveDateIndex: -1
        }
    },
    watch: {
        $route(to) { // 监听路由变化，改变搜索列表内容
            var keyWord = decodeURIComponent(to.params.keyWord);
            if(keyWord == 'All') return
            if(keyWord!=''&&keyWord!=null&&keyWord!=undefined&&keyWord!='null'&&keyWord!='undefined'){
                this.search = keyWord;
            }else{
                this.search = '';
            }
            this.getSearchList();
        },
        language(to) { // 监听语言变化，修改分页栏中英文
            var that = this;
            this.$i18n.locale = to;
            $.cookie('language',to);
            $('.toPage').remove();
            if(to==='zh-CN'){
                $('.el-pagination').append('<div class="toPage">'+
                    '<input id="pageNum" type="text">'+
                    '<p id="pageChange">跳转</p>'+
                '</div>')
                $('#pageChange').click(function(){
                    var num = Number($('#pageNum').val());
                    if(!isNaN(num)){
                        that.pageIndex = num;
                        that.getSearchList();
                    }
                })
                $('.content-container').css({
                    "padding-bottom": "1rem",
                    "background": "#FFF"
                })
                $('.el-pagination').css({
                    "bottom": "0.6rem"
                })
            }else{
                $('.el-pagination').append('<div class="toPage">'+
                    '<input id="pageNum" type="text">'+
                    '<p id="pageChange">Redirect</p>'+
                '</div>')
                $('#pageChange').click(function(){
                    var num = Number($('#pageNum').val());
                    if(!isNaN(num)){
                        that.pageIndex = num;
                        that.getSearchList();
                    }
                })
                $('.content-container').css({
                    "padding-bottom": "2rem",
                    "background": "#FFF"
                })
                $('.el-pagination').css({
                    "bottom": "-0.3rem"
                })
            }
        },
        search(to) {
            if(to.length>0){
                this.isNull = false;
                this.isFocus = true;
                $('.searchInput-container input').focus();
            }else{
                this.isNull = true;
            }
        }
    },
    methods: {
        setDateSearchList(key,index) {
            if(this.saveDateIndex>=index){
              this.dateIndex=index;
              this.dateType=key;
              this.getSearchList()
            }
        },
        leaveFocus() {
            var that = this;
            setTimeout(function(){
                that.isFocus = false;
            },150)
        },
        delSearch() {
            this.search = '';
            $('.searchInput-container input').focus();
        },
        getInfo() { //获取用户信息
            var that = this;
            require('../utils.js').requestWithToken({
                url: require('../config.json').urlBase + require('../config.json').url.user.info,
                success: function (res) {
                    if(res.code!='10000'){
                        localStorage.removeItem('uid');
                        localStorage.removeItem('unid');
                        localStorage.removeItem('name');
                        localStorage.removeItem('role');
                        that.isLogin = false;
                        that.role = '';
                    }
                },
                error: function () {
                    if(that.language==='zh-CN'){
                        that.$message({
                            type: 'error',
                            message: '网络错误'
                        })
                    }else{
                        that.$message({
                            type: 'error',
                            message: 'Network Error'
                        })
                    }
                }
            })
        },
        getProjectFileList() { //获取项目文件下载列表
            var that = this;
            that.pageNum = 18;
            require('../utils.js').requestWithToken({
                url: require('../config.json').urlBase + require('../config.json').url.list.projlist,
                data: {
                    page: that.pageIndex,
                    num: that.pageNum
                },
                success: function(res) {
                    if(res.code=='10000'){
                        that.projectFileList = res.result.list
                        if(Number(res.result.page.countNum)===0){
                          that.pageTotal = 1;
                        }else{
                          that.pageTotal = Number(res.result.page.countNum);
                        }
                    }else{
                        if(that.language=='zh-CN'){
                            that.$message({
                                type: 'warning',
                                message: res.error.message.zh_msg
                            })
                        }else{
                            that.$message({
                                type: 'warning',
                                message: res.error.message.en_msg
                            })
                        }
                    }
                },
                error: function() {
                    if(that.language=='zh-CN'){
                        that.$message({
                            type: 'error',
                            message: '网络错误'
                        })
                    }else{
                        that.$message({
                            type: 'error',
                            message: 'Network Error'
                        })
                    }
                }
            })
        },
        changeCategoryType(index,type) { //选择检索类别
            this.getInfo();
            if(type==='material'){ // 角色为1或3或4的情况下显示素材列表内容
                if(this.role!=1&&this.role!=3&&this.role!=4){
                    if(this.language==='zh-CN'){
                        this.$message({
                            type: 'warning',
                            message: '请登录官方账号，获取更多视频操作权限。'
                        })
                        return false;
                    }else{
                        this.$message({
                            type: 'warning',
                            message: 'Please log in to the official account to get more video operation rights.'
                        })
                        return false;
                    }
                }else{
                    bus.showAll = false;
                    this.index = index;
                    this.isProjectDownload = false;
                    this.categoryType = type;
                    this.pageIndex = 1;
                    this.getSearchList();
                }
            }else if (type==='project'){ // 工程文件状态下获取工程文件下载列表
                bus.showAll = false;
                this.index = index;
                this.isProjectDownload = true;
                this.pageIndex = 1;
                this.getProjectFileList();
            }else{
                if(type=='match'){
                  bus.showAll = false;
                  this.type = '';
                  this.typeIndex = 99;
                }
                if(type=='person'){
                    bus.showAll = false;
                }
                if(type=='all'){
                    bus.showAll = true;
                }
                this.index = index;
                this.isProjectDownload = false;
                this.categoryType = type;
                this.pageIndex = 1;
                this.getSearchList();
            }
        },
        changeProjectDownload(index){ //选择工程文件下载，显示工程文件列表
            this.index = index;
            this.isProjectDownload = true;
            this.pageIndex = 1;
        },
        projectFileDownload(idNum) { //工程文件下载
            if(this.isPc){
                var body = document.body
                var jsonrpc1 = "2.0";
                var timetamp1 = (new Date()).valueOf();
                var nonce1 = Math.random().toString(36).substr(2);
                var key = "zPVAVhZxHS2b9fAskODfZk28pYsNW8sd";
                var uid1 = localStorage.getItem('uid');
                var unid1 = localStorage.getItem('unid');
                var string1 = "";
                string1 = "jsonrpc=" + jsonrpc1+ "&nonce=" + nonce1 + "&timetamp=" + timetamp1 + "&uid=" + uid1 + "&unid=" + unid1 + key;
                var sign1 = $.md5(string1);
                var form = document.createElement('form')
                form.method = 'post'
                form.action = require('../config.json').urlBase + require('../config.json').url.detail.projdownload
                var jsonrpc = document.createElement('input')
                jsonrpc.type = 'hidden'
                jsonrpc.name = 'jsonrpc'
                jsonrpc.value = jsonrpc1
                var uid = document.createElement('input')
                uid.type = 'hidden'
                uid.name = 'uid'
                uid.value = uid1
                var unid = document.createElement('input')
                unid.type = 'hidden'
                unid.name = 'unid'
                unid.value = unid1
                var timetamp = document.createElement('input')
                timetamp.type = 'hidden'
                timetamp.name = 'timetamp'
                timetamp.value = timetamp1
                var nonce = document.createElement('input')
                nonce.type = 'hidden'
                nonce.name = 'nonce'
                nonce.value = nonce1
                var sign = document.createElement('input')
                sign.type = 'hidden'
                sign.name = 'sign'
                sign.value = sign1
                var id = document.createElement('input')
                id.type = 'hidden'
                id.name = 'basename'
                id.value = idNum
                form.appendChild(jsonrpc)
                form.appendChild(uid)
                form.appendChild(unid)
                form.appendChild(timetamp)
                form.appendChild(nonce)
                form.appendChild(sign)
                form.appendChild(id)
                body.appendChild(form)
                form.submit()
                body.removeChild(form)
            }else{ // 如移动端点击下载按钮提示提示语
                if(this.language=='zh-CN'){
                    this.$message({
                        type: 'warning',
                        message: '建议使用电脑下载视频'
                    })
                }else{
                    this.$message({
                        type: 'warning',
                        message: 'It is recommended to use a computer to download videos'
                    })
                }
            }
        },
        searchKeyWord() { //搜索关键词
            var that = this;
            var keyWord = that.search;
            this.getSearchList();
            if(keyWord!=''&&keyWord!=null&&keyWord!=undefined){
                this.$router.push({
                    name: 'searchList',
                    params: {
                        keyWord: encodeURIComponent(keyWord)
                    }
                })
            }else{
                this.$router.push({
                    name: 'searchList',
                    params: {
                        keyWord: null
                    }
                })
            }
        },
        getConfig() { //获取通用信息
            var that = this;
            require('../utils.js').requestWithToken({
                url: require('../config.json').urlBase + require('../config.json').url.user.getConfig,
                success: function(res) {
                    if(res.code==='10000'){
                        that.dailyEvent_ZH = res.result.dailyevents_url.zh_url;
                        that.dailyEvent_EN = res.result.dailyevents_url.en_url;
                        that.logoImg = res.result.logo;
                    }else{
                        if(that.$message==='zh-CN'){
                            that.$message({
                                type: 'warning',
                                message: res.error.message.zh_msg
                            })
                        }else{
                            that.$message({
                                type: 'warning',
                                message: res.error.message.en_msg
                            })
                        }
                    }
                },
                error: function() {
                    if(that.language==='zh-CN'){
                        that.$message({
                            type: 'error',
                            message: '网络错误'
                        })
                    }else{
                        that.$message({
                            type: 'error',
                            message: 'Network Error'
                        })
                    }
                }
            })
        },
        handleCurrentChange(e) { //页面页数修改
            this.pageIndex = e;
            this.getSearchList();
        },
        changeLanguage() { //页面语言修改
            var language = this.language;
            if(language==='zh-CN'){
                this.language = 'en-US'
            }else{
                this.language = 'zh-CN'
            }
        },
        navigateTo(res) { //跳转
            if(res==='login'){
                this.$route.meta.keepAlive = false;
              this.$router.push({
                  name: 'login',
                  params: {
                    sourceUrl: encodeURIComponent('searchList')
                  }
              })
            }else{
                if(res==='index'){
                    this.$route.meta.keepAlive = false;
                }
              this.$router.push({
                  name: res
              })
            }
        },
        navigateToPDF() { //跳转PDF页面
            if(this.language==='zh-CN'){
                window.open(this.dailyEvent_ZH)
                // window.location.href = this.dailyEvent_ZH
            }else{
                window.open(this.dailyEvent_EN)
                // window.location.href = this.dailyEvent_EN
            }
        },
        navigateToDetail(id,category) { //跳转至视频详细内容页
            this.getInfo();
            if(category==1){
                if(this.isLogin){
                    this.$router.push({
                        name: 'videoDetail',
                        params: {
                            id: id
                        }
                    })
                }else{
                    if(this.language==='zh-CN'){
                        this.$message({
                            type: 'warning',
                            message: '请登录官方账号，获取更多视频操作权限。'
                        })
                    }else{
                        this.$message({
                            type: 'warning',
                            message: 'Please log in to the official account to get more video operation rights.'
                        })
                    }
                }
            }else{
                this.$router.push({
                    name: 'collectionVideo',
                    params: {
                        id: id
                    }
                })
            }
        },
        voiceSearch() {
            bus.$emit('voiceSearch');
        },
        picSearch() {
            bus.$emit('picSearch');
        },
        faceSearch() {
            bus.$emit('faceSearch');
        },
        getSearchList() { //获取搜索列表
            var that = this;
            that.pageNum = 8;
            if(that.categoryType=='all'){
                that.categoryType = ''
            }
            require('../utils.js').requestWithToken({
                url: require('../config.json').urlBase + require('../config.json').url.list.list,
                data: {
                    category: that.categoryType,
                    date: that.dateType,
                    type: that.type,
                    page: that.pageIndex,
                    text: that.search
                },
                success: function(res) {
                    if(res.code==='10000'){
                        var date = new Date();
                        var year = date.getFullYear();
                        var month = date.getMonth()+1;
                        if(month<10){
                          month = '0'+month
                        }
                        var day = date.getDate();
                        if(day<10){
                          day = '0'+day
                        }
                        var nowDay = year+'-'+month+'-'+day;
                        var getDate = new Date(nowDay);
                        res.result.date.forEach(function(el,index){
                            var nowDate = new Date(el.key);
                            if(getDate>=nowDate){
                              // that.dateIndex = index;
                              that.saveDateIndex = Number(index);
                            }
                            if(el.key===that.dateType){
                                that.dateIndex = index
                            }
                        })
                        res.result.type.forEach(function(el,index){
                            if(el.key===that.type){
                                that.typeIndex = index
                            }
                        })
                        that.searchList = res.result;
                        if(Number(res.result.page.countNum)===0){
                          that.pageTotal = 1;
                        }else{
                          that.pageTotal = Number(res.result.page.countNum);
                        }

                        let obj = {};
                        if(that.categoryType){
                            obj.category = that.categoryType;
                        }
                        if(that.dateType){
                            obj.date = that.dateType;
                        }
                        if(that.type){
                            obj.type = that.type;
                        }

                        function isEmpty(obj) {
                            return Object.keys(obj).length === 0;
                        }

                        // that.$router.replace({
                        //     name: 'searchList',
                        //     params: {
                        //         keyWord: that.search || 'All',
                        //         category: that.categoryType ? that.categoryType : '',
                        //     }
                        // })

                        // if((!isEmpty(obj) && that.search) || (!isEmpty(obj) && that.$route.params.keyWord === 'All')){
                        //     console.log(123123)
                        //     const currentRoute = JSON.stringify({
                        //         name: that.$route.name,
                        //         params: that.$route.params,
                        //         query: that.$route.query
                        //     });
                            
                        //     const newRoute = JSON.stringify({
                        //         name: 'searchList',
                        //         params: {
                        //             keyWord: that.search || 'All'
                        //         },
                        //         query: obj
                        //     });
                            
                        //     if (currentRoute !== newRoute) {
                        //         that.$router.push({
                        //             name: 'searchList',
                        //             params: {
                        //                 keyWord: that.search || 'All'
                        //             },
                        //             query: obj
                        //         }).catch(err => {
                        //             if (err.name !== 'NavigationDuplicated') {
                        //                 throw err;
                        //             }
                        //         });
                        //     }
                        // }
                        
                    }else{
                        if(that.language==='zh-CN'){
                            that.$message({
                                type: 'warning',
                                message: res.error.message.zh_msg
                            })
                        }else{
                            that.$message({
                                type: 'warning',
                                message: res.error.message.en_msg
                            })
                        }
                    }
                },
                error: function() {
                    if(that.language==='zh-CN'){
                        that.$message({
                            type: 'error',
                            message: '网络错误'
                        })
                    }else{
                        that.$message({
                            type: 'error',
                            message: 'Network Error'
                        })
                    }
                }
            })
        },
        loginOut() { //退出登录
            var that = this;
            this.getInfo();
            var uid = localStorage.getItem('uid');
            var unid = localStorage.getItem('unid');
            var name = localStorage.getItem('name');
            var role = localStorage.getItem('role');
            if(uid!=''&&uid!=null&&uid!=undefined&&unid!=''&&unid!=null&&unid!=undefined){
                require('../utils.js').requestWithToken({
                    url: require('../config.json').urlBase + require('../config.json').url.user.loginout,
                    data: {
                        uid: this.uid,
                        unid: this.unid
                    },
                    success: function(res) {
                        if(res.code==='10000'){
                            that.isLogin = false;
                            that.name = '';
                            that.uid = '';
                            that.unid = '';
                            localStorage.removeItem('name');
                            localStorage.removeItem('uid');
                            localStorage.removeItem('unid');
                            localStorage.removeItem('role');
                            if(that.language==='zh-CN'){
                                that.$message({
                                    type: 'success',
                                    message: '退出成功'
                                })
                            }else{
                                that.$message({
                                    type: 'success',
                                    message: 'log out successfully'
                                })
                            }
                        }else{
                            if(that.language==='zh-CN'){
                                that.$message({
                                    type: 'warning',
                                    message: res.error.message.zh_msg
                                })
                            }else{
                                that.$message({
                                    type: 'warning',
                                    message: res.error.message.en_msg
                                })
                            }
                        }
                    },
                    error: function() {
                        if(that.language==='zh-CN'){
                            that.$message({
                                type: 'error',
                                message: '网络错误'
                            })
                        }else{
                            that.$message({
                                type: 'error',
                                message: 'Network Error'
                            })
                        }
                    }
                })
            }else{
                if(that.language==='zh-CN'){
                    that.$message({
                        type: 'success',
                        message: '退出成功'
                    })
                }else{
                    that.$message({
                        type: 'success',
                        message: 'log out successfully'
                    })
                }
            }
        },
        IsPC() { //判断是否是PC端
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                  "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
      }
    },
    beforeDestroy() {
        
    },
    mounted() {
        var that = this;
        if(this.language == 'en-US'){
            $('.content-container').css({
                "padding-bottom": "2rem",
                "background": "#FFF"
            })
            $('.el-pagination').css({
                "bottom": "-0.3rem"
            })
        }else{
            $('.content-container').css({
                "padding-bottom": "1rem",
                "background": "#FFF"
            })
            $('.el-pagination').css({
                "bottom": "0.6rem"
            })
        }
        if(this.language==='zh-CN'){
            $('.el-pagination').append('<div class="toPage">'+
                '<input id="pageNum" type="text">'+
                '<p id="pageChange">跳转</p>'+
            '</div>')
        }else{
            $('.el-pagination').append('<div class="toPage">'+
                '<input id="pageNum" type="text">'+
                '<p id="pageChange">Redirect</p>'+
            '</div>')
        }
        setTimeout(function(){
            $('#app').css({
                "height": "auto"
            })
        })
        $('#pageChange').click(function(){
            var num = Number($('#pageNum').val());
            if(!isNaN(num)){
                that.pageIndex = num;
                that.getSearchList();
            }
        })

        this.$route.meta.keepAlive = true;
    },
    created() {
        var that = this;
        this.isPc = this.IsPC();
        this.language = this.$i18n.locale;
        this.getInfo();
        // 获取用户个人信息
        var uid = localStorage.getItem('uid');
        var unid = localStorage.getItem('unid');
        var name = localStorage.getItem('name');
        var role = localStorage.getItem('role');
        var keyWord = decodeURIComponent(this.$route.params.keyWord);
        var date = decodeURIComponent(this.$route.params.date);
        var sport = decodeURIComponent(this.$route.params.sport);
        if(sport=='undefined'&&date!=''&&date!=null&&date!=undefined&&date!='undefined'&&date!='null'){
          sport = date;
          date = keyWord;
          keyWord = null;
        }
        if(date!=''&&date!=undefined&&date!=null&&date!='undefined'&&date!='null'){
            var date1 = new Date();
            var year = date1.getFullYear();
            var month = date1.getMonth()+1;
            if(month<10){
                month = '0'+month;
            }
            var day = date1.getDate();
            if(day<10){
                day = '0'+day;
            }
            var nowDate = year+'-'+month+'-'+day;
            nowDate = new Date(nowDate);
            var getDate = new Date(date);
            if(getDate>nowDate){
                this.dateType = ''
            }else{
                this.dateType = date
            }
        }else{
            this.dateType = ''
        }
        if(sport!=''&&sport!=undefined&&sport!=null&&sport!='undefined'&&sport!='null'){
            this.type = sport
        }else{
            this.type = ''
        }
        if(keyWord!=''&&keyWord!=undefined&&keyWord!=null&&keyWord!='undefined'&&keyWord!='null'&&keyWord!='All'){
            this.search = keyWord;
        }else{
            this.search = '';
        }
        if(uid!=''&&uid!=undefined&&uid!=null&&unid!=''&&unid!=undefined&&unid!=null&&name!=''&&name!=undefined&&name!=null){
            this.name = name;
            this.uid = uid;
            this.unid = unid;
            this.role = role;
            this.isLogin = true;
        }
        if(bus.showAll){
            this.index = 0;
            this.categoryType = '';
            // bus.showAll = false;
        }else{
            if(role==1||role==3||role==4){
                this.index = 1;
                this.categoryType = 'material';
            }else{
                this.index = 2;
                this.categoryType = 'match';
                // if(bus.sportNameCn!=null&&bus.sportNameCn!=undefined&&bus.sportNameCn!=''&&bus.sportNameEn!=null&&bus.sportNameEn!=undefined&&bus.sportNameEn!=''){
                //     if(this.language=='zh-CN'){
                //         this.search = bus.sportNameCn
                //     }else{
                //         this.search = bus.sportNameEn
                //     }
                //     bus.sportNameCn = null;
                //     bus.sportNameEn = null;
                // }
                this.type = '';
                this.typeIndex = 99;
            }
        }

        // if(this.$route.query.category){
        //     this.categoryType = this.$route.query.category;
        // }

        // if(this.$route.query.date){
        //     this.dateType = this.$route.query.date;
        // }

        // if(this.$route.query.type){
        //     this.type = this.$route.query.type;
        // }
        
        // this.getProjectFileList();
        this.getSearchList();
        this.getConfig();
        bus.$on('search',function(e){
            that.search = e.search;
        })
    }
}
</script>
<style scoped>
    .content-container {
        padding-bottom: 1rem !important;
        box-sizing: border-box;
    }
    .header-container {
        position: relative;
        width: 20.08rem;
        height: 20.48rem;
        background: url('../assets/searchListBg.png') no-repeat;
        background-position: top right;
        background-size: 100%;
        background-color: #FFF;
    }

    /* .header-container .mainBg {
        overflow: hidden;
    } */

    .header-container .mainBg .title {
        float: left;
        width: 6.4rem;
        height: 0.8rem;
        margin: 0.99rem 0 0 0.64rem;
        user-select: none;
        cursor: pointer;
    }

    .header-container .mainBg .search-container {
        width: 11.6rem;
        float: right;
        margin-right: 0.64rem;
        margin-top: 1.02rem;
    }

    .header-container .mainBg .search-container .searchTool-container {
        overflow: hidden;
        height: 0.48rem;
        display: flex;
        align-items: center;
        user-select: none;
    }

    .header-container .mainBg .search-container .searchTool-container > div {
        display: flex;
        align-items: center;
        float: left;
        height: 0.48rem;
        font-size: 0.32rem;
        margin-left: 1.2rem;
        cursor: pointer;
    }

    .header-container .mainBg .search-container .searchTool-container > div:hover {
        height: 0.48rem;
        font-size: 0.36rem;
        margin-left: 1.04rem;
        cursor: pointer;
    }

    .header-container .mainBg .search-container .searchTool-container > div.on {
        margin-left: 1.3rem;
    }

    .header-container .mainBg .search-container .searchTool-container > div.on p {
        font-size: 0.28rem;
    }

    .header-container .mainBg .search-container .searchTool-container > div.on:hover p {
        font-size: 0.32rem;
    }

    .header-container .mainBg .search-container .searchTool-container > div.voice-container img {
        width: 0.4rem;
        height: 0.48rem;
    }

    .header-container .mainBg .search-container .searchTool-container > div.pic-container img {
        width: 0.49rem;
        height: 0.47rem;
    }

    .header-container .mainBg .search-container .searchTool-container > div.face-container img {
        width: 0.42rem;
        height: 0.48rem;
    }

    .header-container .mainBg .search-container .searchTool-container > div img {
        float: left;
        margin-right: 0.16rem;
    }

    .header-container .mainBg .search-container .searchTool-container > div p {
        float: left;
        color: #1e69fe;
    }

    .header-container .mainBg .search-container .searchInput-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 11.6rem;
        height: 0.8rem;
        background: #FFF;
        border: 0.02rem solid #1e69fe;
        border-radius: 6px;
        box-sizing: border-box;
        margin-top: 0.2rem;
    }

    .header-container .mainBg .search-container .searchInput-container input {
        width: 100%;
        height: 0.6rem;
        padding: 0 0 0 0.18rem;
        font-size: 0.36rem;
        color: #1e69fe;
        border: none;
        outline: none;
        box-sizing: border-box;
    }

    .header-container .mainBg .search-container .searchInput-container input:focus + .searchIcon {
        width: 0.94rem;
        height: 0.6rem;
        background: url('../assets/searchIconBlueOn.png') no-repeat;
        background-size: 0.46rem 0.46rem;
        background-position: center;
        border-left: 0.02rem solid #cfddfd;
        box-sizing: border-box;
    }

    .header-container .mainBg .search-container .searchInput-container input:focus + .delIcon + .searchIcon {
        width: 0.94rem;
        height: 0.6rem;
        background: url('../assets/searchIconBlueOn.png') no-repeat;
        background-size: 0.46rem 0.46rem;
        background-position: center;
        border-left: 0.02rem solid #cfddfd;
        box-sizing: border-box;
    }

    .header-container .mainBg .search-container .searchInput-container > .delIcon {
        position: relative;
        width: 0.3rem;
        height: 0.3rem;
        margin: 0 0.2rem 0 0.1rem;
        user-select: none;
        cursor: pointer;
    }

    .header-container .mainBg .search-container .searchInput-container > .delIcon img {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 0.3rem;
        height: 0.3rem;
    }

    .header-container .mainBg .search-container .searchInput-container .searchIcon {
        width: 0.94rem;
        height: 0.6rem;
        background: url('../assets/searchIconBlue.png') no-repeat;
        background-size: 0.46rem 0.46rem;
        background-position: center;
        border-left: 0.02rem solid #cfddfd;
        box-sizing: border-box;
        cursor: pointer;
    }

    .header-container .headLine {
        position: absolute;
        top: 0.16rem;
        right: 0.6rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        user-select: none;
    }

    .header-container .headLine li {
        position: relative;
        height: 0.36rem;
        z-index: 2;
        display: flex;
        flex-direction: row;
        align-items: baseline;
        font-size: 0.24rem;
        color: #10163e;
        text-align: center;
        cursor: pointer;
        margin-left: 0.5rem;
    }

    .header-container .headLine li.avatar-container {
        display: flex;
        align-items: center;
    }

    .header-container .headLine li span.avatar {
        width: 0.36rem;
        height: 0.36rem;
        border-radius: 50%;
        background: #FFF;
        background: url('../assets/avatarIcon.png') no-repeat;
        background-size: 0.22rem 0.27rem;
        background-position: center;
        background-color: #FFF;
    }

    .header-container .headLine li::before {
        position: absolute;
        top: 50%;
        left: -0.05rem;
        z-index: -1;
        margin-top: -0.18rem;
        display: block;
        content: '';
        width: 0.36rem;
        height: 0.36rem;
        background: #FFF;
        border-radius: 50%;
    }

    .header-container .headLine li.on::before {
        position: absolute;
        top: 50%;
        left: -0.1rem;
        z-index: -1;
        margin-top: -0.18rem;
        display: block;
        content: '';
        width: 0.36rem;
        height: 0.36rem;
        background: #FFF;
        border-radius: 50%;
    }

    .header-container .headLine li:hover {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 0.28rem;
        color: #1e69fe;
        text-align: center;
        cursor: pointer;
    }

    .header-container .headLine li span {
        display: inline-block;
        /* width: 0.36rem;
        height: 0.36rem;
        line-height: 0.36rem;
        font-size: 0.28rem;
        color: #1e69fe;
        border-radius: 50%;
        background: #FFF; */
        line-height: 0.36rem;
        font-size: 0.28rem;
        color: #1e69fe;
    }

    .header-container .headLine li p {
        line-height: 0.36rem;
    }

    .header-container .headLine li:nth-last-of-type(1)::after {
        display: block;
        content: '';
        width: 0.09rem;
        height: 0.13rem;
        margin-left: 0.07rem;
        background: url('../assets/leftArrow.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .header-container .headLine li:nth-last-of-type(1):hover::after {
        display: block;
        content: '';
        width: 0.09rem;
        height: 0.13rem;
        margin-left: 0.07rem;
        background: url('../assets/leftArrowOn.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .header-container .searchTag-container {
        width: 100%;
        float: left;
        padding: 0 0.64rem;
        margin: 0.74rem 0 0 0;
        box-sizing: border-box;
    }

    .header-container .searchTag-container .mainTag {
        width: 100%;
        height: 0.6rem;
        user-select: none;
    }

    .header-container .searchTag-container .mainTag li {
        position: relative;
        float: left;
        font-size: 0.32rem;
        color: #848a9d;
        margin-right: 0.96rem;
        cursor: pointer;
    }

    .header-container .searchTag-container .mainTag li.on {
        color: #1e69fe;
        font-weight: bold;
    }

    .header-container .searchTag-container .mainTag li.on::after {
        position: absolute;
        left: 50%;
        bottom: -0.18rem;
        display: block;
        content: '';
        width: 0.4rem;
        height: 0.12rem;
        border-radius: 40px;
        background: #1e69fe;
        margin-left: -0.2rem;
    }

    .header-container .searchTag-container .dateTag {
        width: 100%;
        margin-top: 0.38rem;
        overflow: hidden;
        user-select: none;
    }

    .header-container .searchTag-container .dateTag.on {
      margin-bottom: 0.56rem;
    }

    .header-container .searchTag-container .dateTag ul {
        overflow: hidden;
    }

    .header-container .searchTag-container .dateTag ul li:nth-last-of-type(1) {
        margin-right: 0px;
    }

    .header-container .searchTag-container .dateTag > li:nth-of-type(1) {
        margin-right: 0.24rem;
    }

    .header-container .searchTag-container .dateTag li {
        float: left;
        font-size: 0.28rem;
        color: #10163e;
        margin-right: 0.48rem;
        cursor: pointer;
    }

    .header-container .searchTag-container .dateTag li.on {
        color: #1e69fe;
        font-weight: bold;
    }

    .header-container .searchTag-container .dateTag li.un {
        color: #848a9d;
    }

    .header-container .searchTag-container .sportTag {
        width: 100%;
        margin-top: 0.38rem;
        overflow: hidden;
        margin-bottom: 0.56rem;
        user-select: none;
    }

    .header-container .searchTag-container .sportTag > li:nth-of-type(1) {
        margin-right: 0.24rem;
    }

    .header-container .searchTag-container .sportTag li {
        float: left;
        font-size: 0.28rem;
        color: #10163e;
        margin-right: 0.48rem;
        cursor: pointer;
    }

    .header-container .searchTag-container .sportTag li.on {
        color: #1e69fe;
        font-weight: bold;
    }

    .header-container .searchTag-container .sportTag > li {
        float: left;
    }

    .header-container .searchTag-container .sportTag > ul {
        width: 91%;
        float: left;
    }

    .header-container .searchTag-container .sportTag > ul.on {
        width: 85%;
        float: left;
    }

    .header-container .searchTag-container .sportTag > ul li {
        margin-bottom: 0.14rem;
    }

    .header-container .videoList-container {
        width: 100%;
        padding: 0 0.64rem;
        box-sizing: border-box;
        overflow: hidden;
    }

    .header-container .videoList-container li {
        float: left;
        width: 4.52rem;
        height: 5.46rem;
        background: #FFF;
        border-radius: 6px;
        box-sizing: border-box;
        margin: 0 0.24rem 0.4rem 0;
        overflow: hidden;
        box-shadow: 0rem 0.25rem 0.5rem 0px rgba(0,17,101,0.06);
        border: 1px solid #F5F5F6;
        cursor: pointer;
    }

    .header-container .videoList-container li:nth-of-type(4n+0) {
        margin-right: 0px;
    }

    .header-container .videoList-container li .img-container {
        position: relative;
        width: 4.52rem;
        height: 2.52rem;
    }

    .header-container .videoList-container li .img-container .timeInfo {
        position: absolute;
        bottom: -0.38rem;
        right: 0.24rem;
        overflow: hidden;
        user-select: none;
    }

    .header-container .videoList-container li .img-container .timeInfo img {
        display: inline-block;
        vertical-align: middle;
        width: 0.24rem;
        height: 0.3rem;
    }

    .header-container .videoList-container li .img-container .timeInfo p {
        display: inline-block;
        vertical-align: middle;
        font-size: 0.24rem;
        color: #FFF;
    }

    .header-container .videoList-container li .img-container img {
        width: 4.52rem;
        height: 2.52rem;
        user-select: none;
    }

    .header-container .videoList-container li .info .content {
        height: 1.5rem;
        padding: 0 0.2rem;
        font-size: 0.28rem;
        line-height: 0.48rem;
        color: #10163e;
        box-sizing: border-box;
        margin-top: 0.2rem;
        word-break: break-all;
        user-select: none;
    }

    .header-container .videoList-container li .info .size {
        font-size: 0.24rem;
        color: #848a9d;
        padding: 0px 0.2rem;
        box-sizing: border-box;
        margin: 0.3rem 0 0.1rem 0;
        user-select: none;
    }

    .header-container .videoList-container li .info .date {
        font-size: 0.24rem;
        color: #848a9d;
        padding: 0px 0.2rem;
        box-sizing: border-box;
        user-select: none;
    }

    .header-container .downLoadList-container {
        width: 100%;
        padding: 0.5rem 0.64rem 0;
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .header-container .downLoadList-container > li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        min-height: 0.8rem;
        padding: 0 0.2rem;
        font-size: 0.28rem;
        color: #10163e;
        border-bottom: 0.02rem solid #e0e7ff;
        box-sizing: border-box;
    }

    .header-container .downLoadList-container > li > p {
        width: 85%;
        word-break: break-all;
        user-select: none;
    }

    .header-container .downLoadList-container > li > span {
        cursor: pointer;
        color: #1e69fe;
        font-size: 0.24rem;
        user-select: none;
    }

    .header-container .downLoadList-container > li > span:hover {
        color: #10163e;
    }

    .el-pagination {
        position: absolute;
        bottom: 0.6rem;
        right: 0px;
        /* margin-bottom: 0.6rem; */
        height: 0.6rem;
        text-align: right;
        margin-right: 0.64rem;
        /* margin-top: 0.4rem; */
        user-select: none;
    }
</style>
<style>
    .el-pager li {
        min-width: 0.6rem;
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.28rem;
        color: #848a9d;
    }

    .el-pager li:hover {
        color: #2b70fd;
    }

    .el-pager li.active {
        background: #409EFF;
        border-radius: 50%;
        color: #FFF;
        background: linear-gradient(to right, #5086f9 , #2b70fd);
    }

    .el-pager li.btn-quicknext, .el-pager li.btn-quickprev {
        line-height: 0.7rem;
        color: #848a9d;
    }

    .toPage {
        float: right;
        display: flex;
        align-items: center;
        width: 2.2rem;
        height: 0.6rem;
        background: linear-gradient(to right, #5e8df7 , #1e69fe);
        border-radius: 40px;
        box-sizing: border-box;
        margin-left: 0.36rem;
        overflow: hidden;
    }

    .toPage input {
        float: left;
        width: 0.98rem;
        height: 0.4rem;
        font-size: 0.28rem;
        color: #FFF;
        text-align: center;
        border: none;
        outline: none;
        padding: 0 0.2rem;
        box-sizing: border-box;
    }

    .toPage p {
        float: left;
        width: 1.22rem;
        height: 0.4rem;
        font-size: 0.28rem;
        color: #FFF;
        text-align: center;
        border-left: 0.02rem solid #83abfd;
        box-sizing: border-box;
        font-weight: normal !important;
        cursor: pointer;
    }
</style>
